
































































































import {
  entries as loadEntries,
  createEntry,
  updateEntry,
  deleteEntry,
  publish,
} from "@/services/glossary.service";

// Die Fehler-Tokens, die dieses Backend kennt (gemessen an
// `app/api/controllers/glossary.js`). Angezeigt wird immer die Uebersetzung
// des Tokens, nie der Text aus der Antwort; ein unbekanntes Token faellt auf
// eine allgemeine Meldung zurueck, statt einen fehlenden i18n-Schluessel
// anzuzeigen.
const KNOWN_ERROR_TOKENS = [
  "GLOSSARY_FORBIDDEN",
  "GLOSSARY_INVALID_TERM",
  "GLOSSARY_DUPLICATE_TERM",
  "GLOSSARY_ENTRY_NOT_FOUND",
  "GLOSSARY_LAST_ENTRY",
  "GLOSSARY_EMPTY",
  "GLOSSARY_NOT_CONFIGURED",
  "GLOSSARY_PUBLISH_FAILED",
];

export default {
  data() {
    return {
      initLoaded: false,
      entry_list: [],
      published_at: null,
      has_unpublished_changes: false,

      entry_dialog: false,
      entry_progress: false,
      entry_error: "",
      entry_item: { de: "", en: "" },
      update_uid: null,

      publish_progress: false,

      snackbar: false,
      snackbar_text: "",

      search: "",
    };
  },
  computed: {
    headers: function () {
      return [
        { text: this.$t("GLOSSARY.COLUMN_DE"), value: "de" },
        { text: this.$t("GLOSSARY.COLUMN_EN"), value: "en" },
        { text: "", value: "uid", sortable: false },
      ];
    },
    stateText: function () {
      if (!this.published_at) {
        return this.$t("GLOSSARY.STATE_NEVER");
      }
      if (this.has_unpublished_changes) {
        return this.$t("GLOSSARY.STATE_UNPUBLISHED");
      }
      return this.$t("GLOSSARY.STATE_PUBLISHED");
    },
    /**
     * Ob die Loesch-Aktion angeboten wird.
     *
     * Das Backend lehnt das Loeschen des letzten verbliebenen Begriffspaars mit
     * `GLOSSARY_LAST_ENTRY` ab, weil sich ein leerer Bestand nicht an DeepL
     * uebertragen laesst. Diese Abfrage erspart dem Anwender den Fehlschlag —
     * sie ersetzt die Regel nicht: die Liste hier kann veraltet sein, und zwei
     * gleichzeitige Loeschungen sieht ohnehin nur der Server. Die Antwort wird
     * deshalb weiter behandelt.
     */
    canDelete: function () {
      return this.entry_list.length > 1;
    },
    stateType: function () {
      if (this.has_unpublished_changes) return "warning";
      // Ohne je erfolgte Uebertragung ist "gruen" die falsche Auskunft, auch
      // wenn es nichts zu uebertragen gibt.
      return this.published_at ? "success" : "info";
    },
  },
  mounted() {
    this.$store.state.headerTitle = this.$t("NAVI.GLOSSARY");

    loadEntries()
      .then((data) => {
        this.applyPayload(data);
        this.initLoaded = true;
      })
      .catch((err) => {
        this.reportError(err, "toast");
      });
  },
  methods: {
    applyPayload(data) {
      this.entry_list = data && data.entries ? data.entries : [];
      this.published_at = data ? data.published_at : null;
      this.has_unpublished_changes = !!(data && data.has_unpublished_changes);
    },

    /**
     * Baut die Anzeige zu einem Fehlschlag.
     *
     * Ein Fehler OHNE Token ist keiner dieses Bereichs (abgelaufenes Token,
     * kein Netz) und geht an `api_error`. Ein Fehler MIT Token wird hier
     * uebersetzt — und ausdruecklich nicht an `api_error` gegeben: der meldet
     * sich bei HTTP 403 ab, und ein fehlendes Glossar-Recht ist kein Grund,
     * jemanden auszuloggen.
     */
    reportError(err, target) {
      const e = err || {};
      if (!e.token) {
        this.$store.dispatch("api_error", e.raw || e);
        return;
      }

      const text = this.errorText(e);
      if (target === "dialog") {
        this.entry_error = text;
        return;
      }
      this.showMessage(text);
    },

    errorText(e) {
      if (KNOWN_ERROR_TOKENS.indexOf(e.token) < 0) {
        return this.$t("GLOSSARY.ERROR.UNKNOWN");
      }
      const field =
        e.field === "en"
          ? this.$t("GLOSSARY.COLUMN_EN")
          : this.$t("GLOSSARY.COLUMN_DE");
      return this.$t("GLOSSARY.ERROR." + e.token, { field: field });
    },

    showMessage(text) {
      this.snackbar_text = text;
      this.snackbar = true;
    },

    openEntry(ev, item) {
      ev.preventDefault();
      this.entry_error = "";
      this.entry_item = { de: item.de || "", en: item.en || "" };
      this.update_uid = item.uid || null;
      this.entry_dialog = true;
    },

    closeEntry() {
      this.entry_dialog = false;
      this.entry_error = "";
    },

    saveEntry() {
      this.entry_error = "";
      this.entry_progress = true;

      const request = this.update_uid
        ? updateEntry(this.update_uid, this.entry_item.de, this.entry_item.en)
        : createEntry(this.entry_item.de, this.entry_item.en);

      request
        .then((data) => {
          this.applyPayload(data);
          this.entry_progress = false;
          this.entry_dialog = false;
        })
        .catch((err) => {
          this.entry_progress = false;
          this.reportError(err, "dialog");
        });
    },

    deleteEntry(ev) {
      ev.preventDefault();
      if (!this.update_uid) return;
      if (!this.canDelete) return;
      if (!confirm(this.$t("GLOSSARY.DELETE_CONFIRM"))) return;

      this.entry_error = "";
      this.entry_progress = true;

      deleteEntry(this.update_uid)
        .then((data) => {
          this.applyPayload(data);
          this.entry_progress = false;
          this.entry_dialog = false;
        })
        .catch((err) => {
          this.entry_progress = false;
          this.reportError(err, "dialog");
        });
    },

    publishEntries() {
      if (!confirm(this.$t("GLOSSARY.PUBLISH_CONFIRM"))) return;

      this.publish_progress = true;
      publish()
        .then((data) => {
          this.applyPayload(data);
          this.publish_progress = false;
          this.showMessage(this.$t("GLOSSARY.PUBLISH_DONE"));
        })
        .catch((err) => {
          this.publish_progress = false;
          this.reportError(err, "toast");
        });
    },
  },
};
